import Vue from 'vue'
import VueRouter from 'vue-router'
// import store from 'vuex'

Vue.use(VueRouter)

const load = component =>
  () =>
    import(`@/components/templates/${component}.vue`)

const routes = [
  {
    path: '/Home',
    name: 'Home',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Home')
    }
  },
  {
    path: '/SignUp',
    name: 'SignUp',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('SignUp')
    }
  },
  {
    path: '/SignIn',
    name: 'SignIn',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('SignIn')
    }
  },
  {
    path: '/UserProfile',
    name: 'UserProfile',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('UserProfile')
    }
  },
  {
    path: '/Robots',
    name: 'Robots',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Robots')
    }
  },
  {
    path: '/InspectRobot',
    name: 'InspectRobot',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('InspectRobot')
    }
  },
  {
    path: '/Keys',
    name: 'Keys',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Keys')
    }
  },
  {
    path: '/Groups',
    name: 'Groups',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Groups')
    }
  },
  {
    path: '/Roleta',
    name: 'Roleta',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Roleta')
    }
  },
  {
    path: '/Fights',
    name: 'Fights',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Fights')
    }
  },
  {
    path: '/Eventos',
    name: 'Eventos',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Eventos')
    }
  },
  {
    // Classificação final do evento. Pública: é o link que a organização manda
    // para as equipes no fim da competição.
    path: '/Podio',
    name: 'Podio',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Podio')
    }
  },
  {
    // Regulamentos oficiais em PDF, abertos dentro do sistema. Leitura pública:
    // competidor deslogado também precisa consultar as regras.
    path: '/Regras',
    name: 'Regras',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Regras')
    }
  },
  {
    path: '/EventoDetalhe',
    name: 'EventoDetalhe',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('EventoDetalhe')
    }
  },
  {
    // Cronômetro do round em tela cheia, para abrir numa segunda aba/telão.
    // Público: quem projeta não precisa estar logado; quem controla é o juiz.
    path: '/Cronometro',
    name: 'Cronometro',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Cronometro')
    }
  },
  {
    path: '/CurrentFight',
    name: 'CurrentFight',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('CurrentFight')
    }
  },
  {
    path: '/CriarEvento',
    name: 'CriarEvento',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('CriarEvento')
    }
  },
  {
    path: '/Inscricoes',
    name: 'Inscricoes',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('Inscricoes')
    }
  },
  {
    path: '/MinhaEquipe',
    name: 'MinhaEquipe',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('MinhaEquipe')
    }
  },
  {
    path: '/EditarEvento',
    name: 'EditarEvento',
    meta: {
      auth: false,
      withToken: false
    },
    components: {
      content: load('EditarEvento')
    }
  },
  {
    path: '/',
    redirect: '/Home'
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Recuperação de ChunkLoadError: após um deploy, uma aba antiga tem um app.js que
// referencia chunks com hashes que já não existem no servidor (o nginx devolve o
// index.html no lugar do .js → "Unexpected token '<'"). Quando a navegação falha
// por isso, recarrega a página UMA vez para buscar o bundle novo. A trava em
// sessionStorage evita loop de reload caso o erro persista por outro motivo.
const CHUNK_ERR = /Loading chunk .* failed|ChunkLoadError|Unexpected token '<'|error loading dynamically imported module/i
const RELOAD_FLAG = 'chunk-reload-once'

router.onError((error) => {
  if (error && CHUNK_ERR.test(error.message || '')) {
    if (!sessionStorage.getItem(RELOAD_FLAG)) {
      sessionStorage.setItem(RELOAD_FLAG, '1')
      window.location.reload()
    }
  }
})

// Navegou com sucesso → limpa a trava (permite nova recuperação no próximo deploy).
router.afterEach(() => {
  sessionStorage.removeItem(RELOAD_FLAG)
})

// router.beforeEach(
//   (to, from, next) => {
//     if (to.meta.public) {
//       return next()
//     }
//     AuthBeforeEach(to, from, next, router, store)
//   }
// )

export default router
